<template>
  <div id="algorithmDetail">
    <div>
      <nav-bar @searchInfo="redrectSearchInfo"></nav-bar>
    </div>
    <div class="content">
      <div class="crumbs">
       <!--   <div class="widthStyle">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
             <el-breadcrumb-item>活动管理</el-breadcrumb-item>
            <el-breadcrumb-item>活动列表</el-breadcrumb-item>
            <el-breadcrumb-item>活动详情</el-breadcrumb-item> 
          </el-breadcrumb> 
		  
        </div>-->
      </div>
      <div class="widthStyle tableBox">
        <el-tabs v-model="activeName" type="border-card" @tab-click="handleTabchange">
          <!-- <el-tab-pane :disabled="true" label="知识橱窗" name="first">知识橱窗</el-tab-pane> -->
          <el-tab-pane name="second">
            <span slot="label">
              <span>天算</span><!-- <span style="font-size: 14px;">(25713)</span> -->
            </span>
            <!-- <div class="freeTrial">
              <div>
                2019年8月25日17:53之前
              </div>
              <div></div>
              <div>可试用<span>99</span>次</div>
            </div> -->
            <div class="container">
              <div class="container-table1">
               <!-- <h3 style="text-align: center;">{{ baseinfo.knowledgeName }}</h3> -->
				 <h3 style="text-align: center;">常用物质物性数据</h3>
                <div class="flexRow flexRowBetween">
                  <div class="width48">
                    <div class="margin20">
                      <div class="title1">物料基本信息</div>
                      <div class="lines"></div>
                      <div class="msg flexRow flexRowBetween">
                        <div class="flexRow flexRowBetween width65 align"
                          v-for="(item, index) in baseinfo.knowledgeMaterielParms" v-if="index < 10">
                          <!-- 为了显示美观 控制物料信息显示在12条之内 -->
                          <div class="fn14Sty">{{ item.name }}:</div>
                          <div class="inputBox">
                            <el-input :disabled="true" v-model="item.value"></el-input>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="title1">物料描述</div>
                      <div class="lines"></div>
                      <div>
                        <el-input type="textarea" autosize readonly v-model="baseinfo.materielContent">
                        </el-input>
                      </div>
                    </div>
                  </div>
                  <div class="width45">
                    <div class="title1">物料物性计算</div>
                    <div class="lines"></div>
                    <div>

                      <div class="rows flexRow align" v-for="knowledgeToolsDetailParam in knowledgeToolsDetailParamList"
                        v-show="knowledgeToolsDetailParam.dataSource == 'HAND'">
                        <div class="rowLeft fn14">{{ knowledgeToolsDetailParam.code }}-{{ knowledgeToolsDetailParam.title
                        }}
                          <span v-if="knowledgeToolsDetailParam.unit != ''">({{ knowledgeToolsDetailParam.unit }})</span>:
                        </div>
                        <div class="rowRight">
                          <el-form @submit.native.prevent :model="knowledgeToolsDetailParam" ref="ruleForm"
                            :rules="rules">
                            <el-form-item prop="codevalue" @keyup.enter.native="exec()">
                              <el-input v-model="knowledgeToolsDetailParam.codevalue"></el-input>
                            </el-form-item>
                          </el-form>
                        </div>
                      </div>

                      <div>
                        <div class="padding0 rows flexRow align" v-for="item in knowledgeToolsDetailFormulaList">
                          <!-- @zz 2023年11月28日16:29:20 修改, 隐藏一些参数  -->
                          <!-- <template v-if="item.title !== '对比温度Tbr'"> -->
                          <template v-if="item.title == '对比温度Tbr'">
                            <div></div>
                          </template>
                          <template v-else-if="item.title == '自然数'">
                            <div></div>
                          </template>
                          <template v-else-if="item.title == '汽发焓常数'">
                            <div></div>
                          </template>
                          <template v-else>
                            <div class="rowLeft fn14">
                              {{ item.code }}-{{ item.title }}
                              <span v-if="item.unit != ''">({{ item.unit }})
                              </span>
                            </div>
                            <div class="rowRight">
                              <el-input :disabled="true" v-model="item.codevalue"></el-input>
                            </div>
                          </template>

                        </div>
                      </div>

                      <div style="text-align: center;">
                        <el-button class="bottomBtn" @click="exec()">天算</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </el-tab-pane>
          <!--   <el-tab-pane name="three" label="参考资料">
            <div class="introduction tabPaneIntroduction">
              <p class="fn14weight">
                知识简介：
              </p>
              <p class="fn14 tabPanejianjie color777">{{baseinfo.materielContent}}</p>
            </div>
        </el-tab-pane> -->
          <el-tab-pane name="four" label="您的建议">
            <div class="comment">
              <div class="commentContent">
                <!-- <p class="fn14Sty1">共25714条意见</p> -->
                <div class="flexRow align">
                  <div class="commentImage">
                    <img class="userPhoto" v-if="$store.state.islogined && $store.state.userImage != null"
                      :src="$store.state.defaultPicUrl + $store.state.userImage" />
                    <img class="userPhoto" v-else src="@/assets/images/touxiang.jpg" />
                  </div>
                  <div class="flex1">
                    <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="suggestionText" maxlength="1000"
                      show-word-limit>
                    </el-input>
                  </div>
                </div>
                <div class="submitBtn" @click="submitJy">
                  <span>提交</span>
                </div>
                <div class="commentList">
                  <div class="flexRow marBottom" v-for="item in suggestionList">
                    <div class="commentImage">
                      <img class="userPhoto" v-if="item.photo != null && item.photo != ''"
                        :src="$store.state.defaultPicUrl + item.photo" />
                      <img class="userPhoto" v-else src="@/assets/images/touxiang.jpg" />
                    </div>
                    <div class="flex1">
                      <div class="flexRow flexRowBetween">
                        <div>
                          <div>
                            <span class="fn14Sty2" style="margin-right: 10px;">{{ item.name }}</span>
                            <span class="fn14Sty2">{{ item.time }}</span>
                          </div>
                          <div class="commentText">{{ item.commentText }}</div>
                        </div>
                        <div>
                          <span class="fn14Sty2" style="vertical-align: bottom;cursor: pointer;" @click="loadJyHF(item);"
                            v-if="item.relplyTotal > 0">回复({{ item.relplyTotal }})</span>
                          <span class="fn14Sty2" style="vertical-align: bottom;" v-else>回复({{ item.relplyTotal }})</span>
                          <i class="iconfont icon-dianzan yizan"></i><span v-if="item.fabulous > 0" class="fn14Sty2"
                            style="vertical-align: bottom;">{{ item.fabulous }}</span>
                        </div>
                      </div>
                      <!-- 回复内容 -->
                      <div v-if="item.showHF" class="flexRow flexRowBetween" v-for="items in item.reply">
                        <!-- <div v-if="item.reply.length>0 &&item.showHF" class="flexRow flexRowBetween" v-for="items in item.reply"> -->
                        <div class="commentImage">
                          <img class="userPhoto" v-if="items.photo != null && items.photo != ''"
                            :src="$store.state.defaultPicUrl + items.photo" />
                          <img class="userPhoto" v-else src="@/assets/images/touxiang.jpg" />
                        </div>
                        <div class="flex1">
                          <div class="flexRow flexRowBetween">
                            <div>
                              <div>
                                <span class="fn14Sty2">{{ items.name }}</span>&nbsp;
                                <span class="fn14Sty2">回复</span>&nbsp;
                                <span class="fn14Sty2" style="margin-right: 10px;">{{ item.name }}</span>
                                <span class="fn14Sty2">{{ items.time }}</span>
                              </div>
                              <div class="commentText">{{ items.commentText }}</div>
                            </div>
                            <div>
                              <i class="iconfont icon-dianzan yizan"></i><span v-if="items.fabulous > 0" class="fn14Sty2"
                                style="vertical-align: bottom;">{{ items.fabulous }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 分页 -->
                <div class="commentPage">
                  <el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
                    @prev-click="handlePrevClicks" @next-click="handleNextClicks" :current-page.sync="scurrentPage"
                    :page-sizes="[5, 10, 15, 20]" :page-size="spageSize" layout="sizes,total,prev, pager, next, jumper"
                    :total="stotal">
                  </el-pagination>
                </div>
              </div>
            </div>

          </el-tab-pane>
          <!-- <el-tab-pane name="five">
            <span slot="label">
              <span>评论</span><span style="font-size: 14px;">(25713)</span>
            </span>
            <div class="comment">
              <div class="commentContent">
                <p class="fn14Sty1">共25714条意见</p>
                <div class="flexRow align">
                  <div class="commentImage">
                    <img src="@/assets/images/touxiang.jpg" />
                  </div>
                  <div class="flex1">
                    <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="commentText" maxlength="200"
                      show-word-limit>
                    </el-input>
                  </div>
                </div>
                <div class="submitBtn">
                  <span>提交</span>
                </div>
                <div class="commentList">
                  <div class="flexRow marBottom" v-for="item in commentList">
                    <div class="commentImage">
                      <img src="@/assets/images/touxiang.jpg" />
                    </div>
                    <div class="flex1">
                      <div class="flexRow flexRowBetween">
                        <div>
                          <div>
                            <span class="fn14Sty2" style="margin-right: 10px;">{{item.name}}</span>
                            <span class="fn14Sty2">{{item.time}}</span>
                          </div>
                          <div class="commentText">{{item.commentText}}</div>
                        </div>
                        <div>
                          <i class="iconfont icon-dianzan yizan"></i><span v-if="item.fabulous>0" class="fn14Sty2"
                            style="vertical-align: bottom;">{{item.fabulous}}</span>
                        </div>
                      </div>

                      <div v-if="item.reply.length>0" class="flexRow flexRowBetween" v-for="items in item.reply">
                        <div class="commentImage">
                          <img src="@/assets/images/touxiang.jpg" />
                        </div>
                        <div class="flex1">
                          <div class="flexRow flexRowBetween">
                            <div>
                              <div>
                                <span class="fn14Sty2">{{items.replyNmae}}</span>&nbsp;
                                <span class="fn14Sty2">回复</span>&nbsp;
                                <span class="fn14Sty2" style="margin-right: 10px;">{{item.name}}</span>
                                <span class="fn14Sty2">{{items.replayTime}}</span>
                              </div>
                              <div class="commentText">{{items.replayText}}</div>
                            </div>
                            <div>
                              <i class="iconfont icon-dianzan yizan"></i><span v-if="items.fabulous>0" class="fn14Sty2"
                                style="vertical-align: bottom;">{{items.fabulous}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="commentPage">
                  <el-pagination @size-change="" @current-change="" :current-page="currentPage" :page-sizes="[5, 10, 15, 20]"
                    :page-size="100" :total="20" layout=" sizes, prev, pager, next, jumper">
                  </el-pagination>
                </div>
              </div>
            </div>
          </el-tab-pane> -->
          <!-- <el-tab-pane name="seven" label="知识活性">知识活性</el-tab-pane> -->
        </el-tabs>
      </div>
    </div>
    <el-dialog :title="dialogInfo.title" :visible.sync="dialogInfo.dialogVisible" width="30%">

      <div class="errorBox">
        <div class="flexRow">
          <div class="errorButton">错误编号</div>
          <p class="errorText" v-if="dialogInfo.errorCode">{{ dialogInfo.errorCode }}</p>
          <p class="errorText" v-else>SYSUNKNOWNERROR</p>
        </div>
        <div class="flexRow">
          <div class="errorButton">错误信息</div>
          <div v-if="dialogInfo.htmlText" v-html="dialogInfo.htmlText"></div>
          <div v-else>
            <p class="errorText">对不起，系统出现了异常</p>
            <p class="errorText">请您将此问题反馈给系统管理人员</p>
            <p class="errorText">我们一定会及时修改，谢谢！</p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogInfo.dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogInfo.dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import navBar from '@/components/navBar';
export default ({
  name: "algorithmDetail",
  components: {
    navBar
  },
  data() {
    var checkNum = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入必要参数值'));
      } else {
        // 效验输入值是否是数字
        const checkNumber = /^-?(?:\d*\.\d+|\d+)$/;
        if (checkNumber.test(value))
          callback();
        else
          callback(new Error('参数值必须为数字'));
      }
    }
    return {
      baseinfo: { //知识基本信息
        'knowledgeName': '', //知识名称
        'knowledgeId': this.$route.query.id == undefined ? '' : this.$route.query.id, //知识主键id
        'knowledgeNoMd5': '', //知识编号NoMd5
        'materielId': '', //物料id
        'materielName': '', //物料名称
        'materielContent': '', //物料简介
        'knowledgeMaterielParms': [] //物料参数
      },
      dialogInfo: { //dialog对话框
        title: '提示',
        errorCode: '',//错误编号
        htmlText: "", //html文本
        dialogVisible: false //是否显示  默认否
      },
      rules: {
        codevalue: [{
          required: true,
          message: '请输入必要参数值',
          trigger: 'blur'
        }, {
          validator: checkNum,
          trigger: ['blur', 'change']
        }]
      },
      knowledgeToolsStepList: [], //知识公式
      knowledgeToolsDetailTitleList: [], //知识公式标题
      knowledgeToolsDetailParamList: [{}], //公式参数
      knowledgeToolsDetailFormulaList: [{}], //公式

      suggestionText: "", //建议内容
      suggestionList: [], //建议list
      scurrentPage: 1, //活动页号建议
      spageSize: 5, //页码大小建议
      stotal: 0, //全部/分页数据总数建议

      activeName: "second",
      currentPage: 1, //评论当前页
      tableData: [],
      value: '',
      commentText: "", //评论内容
      commentList: [{
        name: '杨易',
        time: '一周前',
        commentText: '天算平台能否增加蒸发器计算的功能,我将非常期待',
        fabulous: '2',
        reply: []
      },
      {
        name: '海纳',
        time: '一周前',
        commentText: '天算网真棒',
        fabulous: '2',
        reply: [{
          replyNmae: '管理员',
          replayTime: '一周前',
          replayText: '谢谢支持！',
          fabulous: 0
        }]
      },
      {
        name: '管理员',
        time: '一周前',
        commentText: '天算平台上线啦！',
        fabulous: '',
        reply: ''
      },
      ],
      textarea: "水是一种无臭无味的液体，随深度的提高，将由无色变为蓝色。其相对密度为0.99987 (0℃)，沸点为100℃，冰点为0℃。在自然界中，可以气态或液态或固态存在。当形成固态 (结冰)时，密度将减小，体积增大。 水可以溶解许多物质，是最重要的溶剂。一般来讲，绝大多数的生化反应只有在水溶液中才能进行。;硬度： 除了特别制备的水外，一般在水中均含有一定的杂质离子，尤其是钙、镁离子。;通常将含行碳酸钙和镁的水叫暂时硬水，因为这两种化合物在自然状态下是溶解于水的，可以在煮沸时沉淀出来;而含有钙、镁的硫酸盐和氯化物的水则叫永久硬水，不能通过煮沸法沉淀出来。水的硬度就是水中钙、镁离子的含量或其氧化物的含量。;水质硬度单位为mmol／L，曾用德国度(od)为单位。1 od =0.35663mmol／L。硬度在2.85mmol／L(8 od)以上的水即称作为硬水，品尝比较爽快;在2.85mmol／L以下的水则称作为软水，口尝寡淡;我国规定，生活饮用水中的总硬度应不超过8.9mmol／L(25 od)",

    }
  },
  watch: {
    //route.push进来后没有执行获取数据的方法可以watch下路由，有变化后再次获取数据，而不是靠刷新一次来获取数据
    '$route.query.id'(to, from) { //监测路由发生变化 刷新本页
      location.reload();
    }
  },
  created: function () {
    //初始化加载知识信息
    this.loadKnowledgeInfo();
  },
  methods: {
    handleTabchange(tab, event) { //标签页点击事件
      let _this = this;
      let activeName = tab.name; //获取到当前元素的name
      if (activeName === undefined || activeName === null || activeName === '') return;
      if (activeName === 'four') { //您的建议
        _this.loadJy();
      } else if (activeName === 'five') { //评论
        _this.loadYj();
      } else if (activeName === "one") {
        //切换商品橱窗  重新初始化图片滑动插件（防止滑动区域只显示一张图）
        this.swiperFlag = true;
        this.swiperInit();
      }
    },
    //搜索
    redrectSearchInfo(params) {
      let searchText = params.searchText;
      let searchType = params.searchType;
      this.$router.push({
        path: "/knowledgeMarket",
        query: {
          "searchText": searchText,
          "searchType": searchType
        }
      });
    },
    //初始化加载知识信息
    loadKnowledgeInfo() {

      let _this = this;
      //加载商品信息
      let paramdata = {};
      paramdata.url = "/SJHG/publicplat/goods/goods/getKnowledgeInfoJson",
        paramdata.data = {
          'knowledgeId': this.baseinfo.knowledgeId
        };

      //获取数据成功回调方法
      paramdata.onSuccess = function (res) {

        if (res.data.ok) {
          var resultdata = res.data.result;

          //1.知识信息
          let knowledgeInfo = resultdata.knowledgeInfo;
          if (knowledgeInfo) {
            _this.baseinfo.description = knowledgeInfo.content;
            _this.baseinfo.knowledgeNoMd5 = knowledgeInfo.noMd5;
            _this.baseinfo.knowledgeId = knowledgeInfo.id;
            _this.baseinfo.knowledgeName = knowledgeInfo.title;

          }

          //1.2物料信息
          let knowledgeMateriel = resultdata.knowledgeMateriel;
          if (knowledgeMateriel) {
            _this.baseinfo.materielId = knowledgeMateriel.id;
            _this.baseinfo.materielName = knowledgeMateriel.name;
            _this.baseinfo.materielContent = knowledgeMateriel.remarks;
          }

          //1.2物料参数
          let knowledgeMaterielParms = resultdata.knowledgeMaterielParms;
          if (knowledgeMaterielParms) {
            _this.baseinfo.knowledgeMaterielParms = knowledgeMaterielParms;
          }
          // map.put("knowledgeMateriel", knowledgeMateriel);
          // 		map.put("knowledgeMaterielParms", knowledgeMateriel.getTitleValueJList());
          // 'materielId':'', //物料id
          // 'materielName':'' ,//物料名称
          // 'knowledgeMaterielParms':[]//物料参数

          //2.商品知识公式
          let knowledgeToolsStepList = resultdata.knowledgeToolsStepList;
          _this.knowledgeToolsStepList = knowledgeToolsStepList;

          let knowledgeToolsStep_ = resultdata.knowledgeToolsStepList[0];

          //组装公式标题
          _this.knowledgeToolsDetailTitleList = [];
          let knowledgeToolsDetailTitleList_ = knowledgeToolsStep_.knowledgeToolsDetailTitleList;
          knowledgeToolsDetailTitleList_.forEach(item => {
            _this.knowledgeToolsDetailTitleList.push({
              'title': item.title
            });
          });

          // 组装公式参数
          _this.knowledgeToolsDetailParamList = [];
          let knowledgeToolsDetailParamList_ = knowledgeToolsStep_.knowledgeToolsDetailParamList;
          knowledgeToolsDetailParamList_.forEach(item => {
            let codevalue = '';
            if (item.dataSource == 'MATERIEL') {
              codevalue = _this.baseinfo.materielId;
            }
            _this.knowledgeToolsDetailParamList.push({
              'title': item.title,
              'unit': item.unit,
              'codevalue': codevalue,
              'code': item.code,
              'dataSource': item.dataSource,
              'dataValue': item.dataValue //物料id
            });
          });

          //组装公式
          _this.knowledgeToolsDetailFormulaList = [];
          let knowledgeToolsDetailFormulaList_ = knowledgeToolsStep_.knowledgeToolsDetailFormulaList;
          knowledgeToolsDetailFormulaList_.forEach(item => {
            _this.knowledgeToolsDetailFormulaList.push({
              'title': item.title,
              'unit': item.unit,
              'codevalue': '',
              'code': item.code,
              'dataSource': item.dataSource,
              'dataValue': item.dataValue
            });
          });


          //console.log('--------------');
          //console.log(resultdata);
          //console.log('--------------');


        } else {
          console.log(res);
          _this.$alert(res.data, '加载知识信息异常', {
            dangerouslyUseHTMLString: true
          });
        }
      }

      _this.$axiosUtil.postServer(paramdata);
    },
    exec() {
      //计算
      let _this = this;

      //2.操作账号
      let userid_ = _this.$store.state.userId != null ? _this.$store.state.userId : '';

      if (!userid_) {
        _this.$confirm('请先登录账号再天算, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.$router.push("/userLogin");

        }).catch(() => {

        });
        return;
      }

      //组装计算所需的json参数
      let objJson = {};
      //校验信息(不空时校验未通过不能执行天算操作)
      let validateMsg = '';
      //公式参数
      _this.knowledgeToolsDetailParamList.forEach(item => {
        if (item.dataSource == 'MATERIEL') {
          objJson['dataValue'] = item.codevalue;
        } else if (item.dataSource == 'DICT') {
          objJson[item.code] = item.codevalue;
        } else {
          objJson[item.code] = item.codevalue;
        }
        if (!item.codevalue) {
          if (validateMsg) {
            validateMsg += '、'
          }
          validateMsg += item.code + '-' + item.title;
          if (item.unit) {
            validateMsg += '(' + item.unit + ')';
          }
        }
      });

      //参数不能为空
      if (validateMsg) {
        _this.$message({
          message: '请录入必要参数：' + validateMsg,
          type: 'warning'
        });
        // 执行element的验证，将提示信息显示出来
        _this.$refs['ruleForm'].forEach(item => {
          if (!item.disabled) { //input框被disabled则不需要验证
            item.validate((valid) => {
              if (!valid) {
                return false
              } else {
                return true
              }
            })
          }
        })
        return;
      }


      //公式属性符号（此时值为空 由计算得出结果）
      _this.knowledgeToolsDetailFormulaList.forEach(item => {
        objJson[item.code] = item.codevalue;
      });
      objJson['knowledgeNo'] = _this.baseinfo.knowledgeNoMd5;
      objJson['knowledgeId'] = _this.baseinfo.knowledgeId;
      //知识公式form表单json
      let paramsJson = JSON.stringify(objJson);

      //加载商品信息
      let paramdata = {};
      paramdata.url = "/SJHG/publicplat/goods/goods/calcKnowledgeInfo",
        paramdata.data = {
          'knowledgeId': _this.baseinfo.knowledgeId, //知识id
          'knowledgeNo': _this.baseinfo.knowledgeNoMd5, //知识noMD5
          'paramsJson': paramsJson
        };
      //获取数据成功回调方法
      paramdata.onSuccess = _this.loadCalcResult;

      _this.$axiosUtil.postServer(paramdata);
    },
    loadCalcResult(res) { //加载计算结果
      let _this = this;
      if (res.data.ok) {
        var calc_result = res.data.result.calc_result;
        if (!calc_result) {
          var calcMsg = res.data.result.calcMsg;
          _this.$message({
            message: t + '失败,原因：' + calcMsg,
            type: 'error'
          });
          return;
        }
        //2、遍历公式数组获取计算结果值并加载到页面
        var calc_result_jsonObj = JSON.parse(calc_result);
        _this.knowledgeToolsDetailFormulaList.forEach(item => {
          var jValue = calc_result_jsonObj[item.code + "_scale_value"]; //key所对应的value
          // var jValue = calc_result_jsonObj[item.code]; //key所对应的value
          // if (jValue) {
          //   try {
          //     jValue = Number(jValue);
          //     jValue = jValue.toFixed(2);

          //   } catch (error) {
          //     console.error(error)
          //   }
          item.codevalue = jValue;
          // }
        });

      } else {
        _this.dialogInfo.title = '天算失败提示';
        _this.dialogInfo.errorCode = res.data.errcode;
        _this.dialogInfo.htmlText = res.data.errmsg;
        _this.dialogInfo.dialogVisible = true;
      }
    },
    submitJy() { //提交建议
      let _this = this;

      //1.知识id
      let knowledgeId = _this.baseinfo.knowledgeId;
      //1.1评论内容
      let suggestionContent = _this.suggestionText;

      if (!suggestionContent) {
        _this.$message({
          message: '请输入建议内容',
          type: 'warning'
        });
        return;
      }

      //2.操作账号
      let userid_ = _this.$store.state.userId != null ? _this.$store.state.userId : '';
      if (!userid_) {
        _this.$confirm('请先登录账号再提交, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.redirectLogin();
        }).catch(() => { });
        return;
      }
      //请求后台操作
      let paramdata = {};
      paramdata.url = "/SJHG/logs/common/logscommon/saveLogsGoodsSuggestion",
        paramdata.data = {
          'knowledgeId': knowledgeId, //知识id
          'suggestionContent': suggestionContent //建议内容
        };

      //请求成功
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          _this.$message({
            message: '提交建议成功！',
            type: 'success'
          });

          //情况录入值
          _this.suggestionText = '';
          //刷新意见列表
          _this.loadJy();
        }
      };
      _this.$axiosUtil.postServer(paramdata);
    },
    loadJy(pageParm) { //加载建议
      let _this = this;

      //1.知识id
      let knowledgeId = _this.baseinfo.knowledgeId;

      //请求后台操作
      let paramdata = {};
      paramdata.url = "/SJHG/logs/common/logscommon/loadLogsGoodsSuggestion",
        paramdata.data = {
          'knowledgeId': knowledgeId //知识id
        };

      //----------------------添加分页参数
      paramdata.data.pageNo = _this.scurrentPage; //页码
      paramdata.data.pageSize = _this.spageSize; //每页数量
      //请求成功
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          var data_ = res.data.result;
          _this.loadJyResult(data_);
        }
      };
      _this.$axiosUtil.postServer(paramdata);
    },
    //加载建议查询结果
    loadJyResult: function (result) {
      let this_ = this;
      let list = [];
      let pageNo = 1;
      let pageSize = 10;
      let count = 0;

      let page_ = result.page; //全部
      //判断有无查询结果
      if (page_.count === undefined || !page_.count || page_.count === null || page_.count === 'null' || page_.count ===
        0) {

      } else {
        list = page_.list;
        pageNo = page_.pageNo;
        pageSize = page_.pageSize;
        count = page_.count;
      }
      this_.scurrentPage = pageNo;
      this_.spageSize = pageSize;
      this_.stotal = count;

      let suggestionList = [];
      list.forEach(item => {
        //建议列表
        suggestionList.push({
          id: item.id,
          name: item.user.name,
          time: item.suggestionTime,
          commentText: item.suggestionContent,
          photo: item.user.photo,
          relplyTotal: item.replyTotal,
          fabulous: '1',
          showHF: false,//默认隐藏回复
          reply: []
        });
      });
      this_.suggestionList = suggestionList;
    },
    handleSizeChanges(val) {
      this.spageSize = val;
      this.loadJy();
    },
    handleCurrentChanges(val) {
      this.scurrentPage = val;
      this.loadJy();
    },
    handlePrevClicks(val) { //上一页
      this.scurrentPage = val;
      this.loadJy();
    },
    handleNextClicks(val) { //下一页
      this.scurrentPage = val;
      this.loadJy();
    },
    loadJyHF(item_) { //加载建议回复
      if (item_.showHF) {
        //隐藏回复
        item_.showHF = false;
      } else {
        //显示回复
        item_.showHF = true;
      }

      let _this = this;
      //请求后台操作
      let paramdata = {};
      paramdata.url = "/SJHG/logs/common/logscommon/loadLogsGoodsSuggestion4Reply",
        paramdata.data = {
          'suggestionId': item_.id //建议id
        };

      //----------------------添加分页参数
      paramdata.data.pageNo = _this.scurrentPage; //页码
      paramdata.data.pageSize = _this.spageSize; //每页数量
      //请求成功
      paramdata.onSuccess = function (res) {
        if (res.data.ok) {
          let page_ = res.data.result.page; //全部
          let list = page_.list;
          //遍历更新建议列表回复
          _this.suggestionList.forEach(items => {
            if (items.id === item_.id) {
              //回复人
              var replys = [];
              list.forEach(item => {
                replys.push({
                  name: item.user.name,
                  time: item.suggestionTime,
                  commentText: item.suggestionContent,
                  photo: item.user.photo,
                });
              });
              _this.$set(items, 'reply', replys);
            }
          });
        }
      };
      _this.$axiosUtil.postServer(paramdata);
    },

  }
})
</script>

<style lang="scss" scoped>
#algorithmDetail {}

.content {
  width: 1280px;
  margin: 0 auto;
  padding-bottom: 20px;
}

>>>.el-input__inner {
  border-radius: $border-radius;
}

.widthStyle {
  width: 100%;
  margin: 0 auto;
}

.crumbs {
  background: #F5726E;
  padding: 15px 0;
}

.crumbs>>>.el-breadcrumb__inner {
  color: #fff;
}

.crumbs>>>.el-icon-arrow-right {
  color: #fff;
}

.tableBox {
  margin-top: 30px;
}

.tableBox>>>.el-tabs__item {
  font-size: 18px;
  color: #736A66;
}

.tableBox>>>.el-tabs--border-card>.el-tabs__header {
  background: #F2F2F2;
}

.tableBox>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
  color: #fff;
  background-color: $color-primary;
  border-color: $color-primary;
}

.tableBox>>>.el-input__inner {
  height: 30px;
  line-height: 30px;
}

.container-table {
  width: 80%;
  margin: 20px auto 0;
}

.textStyle {
  color: #FF0000;
}

.bottomBtn {
  display: inline-block;
  padding: 8px 30px;
  margin: 20px auto 0;
  background: $color-primary;
  color: #fff;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
}

.bottomBtn:hover {
  background: $color-primary-light-1;
}

/* 免费试用框的样式 start*/
.freeTrial {
  position: absolute;
  right: 0;
  top: 0;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  border: 2px solid #FF9900;
  border-top: 0;
}

.freeTrial>div {
  display: inline-block;
  float: left;
}

.freeTrial>div:first-child {
  background: #FBFBFB;
  color: #F9B248;
  padding: 0 3px;
}

.freeTrial>div:nth-child(2) {
  width: 0;
  height: 0;
  border-bottom: 30px solid #FF9900;
  border-left: 15px solid transparent;
}

.freeTrial>div:nth-child(3) {
  color: #fff;
  background: #FF9900;
  padding: 0 3px;
}

.freeTrial>div:nth-child(3) span {
  font-size: 16px;
}

/* end */
.flexRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.flexRowBetween {
  justify-content: space-between;
}

.align {
  align-items: center;
}

.title1 {
  line-height: 16px;
  padding-left: 4px;
  border-left: 2px solid #F5726E;
  text-align: left;
}

.width45 {
  width: 45%;
}

.width48 {
  width: 48%;
}

.width65 {
  width: 65%;
}

.width80 {
  width: 80%;
}



.lines {
  width: 100%;
  height: 1px;
  background: #F2F2F2;
  margin: 5px 0 10px;
}

.fn14Sty {
  width: 53%;
  font-size: 14px;
}

.inputBox {
  width: 45%;
}

.msg>div {
  margin-bottom: 10px;
}

.msg>>>.el-input__inner {
  padding: 0;
  color: #838080;
}

.margin20 {
  margin-bottom: 20px;
}

.rows {
  margin-bottom: 10px;
}

.rowLeft {
  width: 70%;
}

.rowRight {
  width: 30%;
}

.fn14 {
  font-size: 14px;
  text-align: left;
}

.padding0>>>.el-input__inner {
  color: #000;
}

/* 评论start */
.comment {
  width: 80%;
  margin: 0 auto;
}

.fn14Sty1 {
  font-size: 14px;
  color: #ccc;
}

.commentContent {
  width: 600px;
}

.commentImage {
  width: 42px;
  height: 42px;
  margin-right: 20px;
}

.flex1 {
  flex: 1;
}

.submitBtn {
  overflow: hidden;
  padding: 20px 0;
}

.submitBtn>span {
  background: #FF9900;
  padding: 6px 14px;
  color: #fff;
  font-size: 14px;
  float: right;
  border-radius: 4px;
  cursor: pointer;
}

.fn14Sty2 {
  font-size: 14px;
  color: #999;
}

.yizan {
  color: #BFBFBF;
}

.commentText {
  color: #666;
  padding: 10px 0;
}

.marBottom {
  margin-bottom: 10px;
}

.comment>>>.el-pager li.active {
  color: $color-primary;
}

.comment>>>.el-pager li:hover {
  color: $color-primary;
}

/* 控制对话框中异常堆栽信息隐藏 */
>>>.all .main {
  padding: 0;
  margin-left: 0;
}

>>>.all .main .btn {
  display: none;
}

>>>.all .main .font2 {
  display: none;
}

/* 评论end */
.errorBox .flexRow {
  align-items: self-start;
  margin-bottom: 20px;
}

.errorButton {
  padding: 6px 12px;
  background: #71A4B5;
  margin-right: 10px;
  color: #fff;
  border-radius: 4px;
}

.errorText {
  color: #777777;
}

.errorBox p {
  margin: 0 0 10px;
}

>>>.el-dialog__header {
  text-align: center;
}

/* .tableBox>>>.el-input__suffix i {
    line-height: 30px;
  } */

.tableBox>>>.el-select {
  width: 100%;
}

.userPhoto {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/algorithmDetail.vue